import { IconProps } from '../icon';

export function SignatureIcon(props: IconProps) {
  return (
    <svg
      height="19.321"
      viewBox="0 0 20.217 19.321"
      width="20.217"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m14.794 7.943 3.046 1.119-2.533 6.9a7.858 7.858 0 0 1 -2.418 3.092l-.217.593a.373.373 0 0 1 -.348.244.384.384 0 0 1 -.128-.023.372.372 0 0 1 -.22-.477l.205-.56c-.454-.883-.115-3.446.084-3.988zm4.406-7.297a1.771 1.771 0 0 0 -2.1 1.093l-1.835 5 3.045 1.117 1.832-5a1.943 1.943 0 0 0 -.942-2.21zm-5.509 7.039a.742.742 0 0 0 .955-.439l1.936-5.221a.743.743 0 0 0 -1.394-.516l-1.936 5.222a.742.742 0 0 0 .439.954zm-3.116 9.79a2.888 2.888 0 0 0 -.852-.6 2.223 2.223 0 0 0 -.891-.16h-.081a1.155 1.155 0 0 0 -.9-.758 1.814 1.814 0 0 0 -1.4.371c.029-.166.077-.363.113-.506a3.258 3.258 0 0 0 .144-1.376.792.792 0 0 0 -.722-.637 3.835 3.835 0 0 0 -2.336.892c-.7.47-1.142.751-1.587.592-.542-.193-.6-1.66-.336-2.967.233-1.177.667-3.369 1.779-4.365.375-.335.917-.7 1.362-.521a2.517 2.517 0 0 1 1.053 2.1.79.79 0 0 0 1.579-.157 3.884 3.884 0 0 0 -2.049-3.42 2.8 2.8 0 0 0 -2.994.816c-1.392 1.244-1.906 3.355-2.278 5.234-.186.939-.641 4.053 1.357 4.764a3.253 3.253 0 0 0 3-.771c.145-.1.288-.194.427-.28a2.112 2.112 0 0 0 .132 1.7c.516.776 1.245.86 2.166.254.036-.023.077-.05.115-.077a1.072 1.072 0 0 0 .51.51 2.089 2.089 0 0 0 .905.177 1.254 1.254 0 0 1 .288.024 1.372 1.372 0 0 1 .407.307 5.026 5.026 0 0 0 .435.379.79.79 0 0 0 .947-1.265 3.733 3.733 0 0 1 -.293-.26z"
        fill="#a5a5a5"
        transform="translate(0 -.567)"
      />
    </svg>
  );
}

export default SignatureIcon;
